module.exports = __webpack_public_path__ + "static/media/cellfinate_social_1.da5e6705.jpg";